import { motion } from "framer-motion";
import { Apple, Play } from "lucide-react";

const stores = [
  { id: "appstore", label: "App Store", sub: "Download on the", icon: Apple },
  { id: "playstore", label: "Google Play", sub: "Get it on", icon: Play },
];

export default function StoreButtons({ testidPrefix = "store", compact = false }) {
  return (
    <div className={`flex flex-wrap gap-4 ${compact ? "" : "mt-10"}`}>
      {stores.map(({ id, label, sub, icon: Icon }) => (
        <motion.button
          key={id}
          type="button"
          data-testid={`${testidPrefix}-${id}-btn`}
          whileHover={{ y: -3 }}
          whileTap={{ scale: 0.97 }}
          transition={{ type: "spring", stiffness: 400, damping: 22 }}
          className="group flex items-center gap-3 border border-white/20 px-6 py-3.5 text-left hover:bg-white hover:text-black transition-colors duration-300 cursor-pointer"
          onClick={() => {}}
        >
          <Icon className="w-6 h-6" strokeWidth={1.5} />
          <span>
            <span className="block font-mono-label text-[9px] tracking-[0.2em] uppercase text-white/50 group-hover:text-black/60 transition-colors duration-300">
              {sub}
            </span>
            <span className="block text-sm font-medium tracking-wide">
              {label}
            </span>
          </span>
          <span className="ml-3 font-mono-label text-[9px] tracking-[0.2em] uppercase text-[#C9B896] group-hover:text-black/60 transition-colors duration-300">
            Soon
          </span>
        </motion.button>
      ))}
    </div>
  );
}
